<template>
  <div class="c-table">
    <el-table
      ref="table"
      class="common-el-table-styles summary-el-table-styles"
      v-bind="$attrs"
      v-on="$listeners"
      :summary-method="getSummaries"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'coverUrl'">
            <a-image
              :src="scope.row['cover']"
              :width="100"
              :video="scope.row['video']"
              hide-video
              :row="scope.row"
              :double="scope.row['double']"
              :multiple="scope.row['multiple']"
              @on-click="showMedia"
            />
          </div>
          <div v-else-if="col.key === 'imageName'" style="white-space: pre">{{ scope.row.imageName }}</div>
          <div v-else-if="col.key === 'control'" class="pulse-wrap">
            <slot name="control" :scope="scope"></slot>
          </div>
          <span v-else-if="['pv', 'clickNum', 'clickUnitPrice', 'paperUseAmount', 'amount', 'newRoleMoney'].includes(col.key)">
            {{ scope.row[col.key] | toThousands }}
          </span>
          <span v-else-if="getPercent(col.key)">
            {{ scope.row[col.key] | toPercentFixed }}
          </span>
          <span v-else-if="['hasDataCount', 'intelligentScore2', 'intelligentScore'].includes(col.key)">
            {{ scope.row[col.key] | nullFormat }}
          </span>
          <span v-else-if="col.key === 'uploadTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'source'">{{ scope.row[col.key] | sourceType }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { SOURCE_TYPES } from '@/views/material/tags/const'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import mixin from '../mixin'
export default {
  name: 'materialRecordTable',
  mixins: [mixin],
  props: {
    columns: {
      type: Array
    },
    summaries: {
      type: Object
    }
  },
  methods: {
    getPercent(key) {
      if (['createRoleRoi1d', 'createRoleRoi3d', 'createRoleRoi7d', 'createRoleRoi15d', 'createRoleRoi30d'].includes(key)) return true
      return key ? key.indexOf('Rate') > -1 || key.indexOf('Retain') > -1 : false
    },
    showMedia(param) {
      this.$emit('on-show', param)
    },
    getSummaries(param) {
      // 合计自定义
      const { columns } = param
      const sums = []

      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        const values = this.summaries[prop]
        if (typeof values === 'number' && this.getPercent(prop)) {
          sums[index] = toPercentFixed(values)
        } else if (typeof values === 'number') {
          sums[index] = toThousands(values)
        } else {
          sums[index] = values
        }
      })
      return sums
    }
  },

  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  filters: {
    sourceType(value) {
      const { label } = SOURCE_TYPES.find((item) => item.value === value) || {}
      return label || ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  .pulse-wrap {
    width: 90px;
    padding-top: 5px;
    line-height: 1.6;
    padding-right: 15px;
  }
}
</style>
